"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var HandleView = require("./../../../interactionViews/handleView.js");

var logoDataToSVG = require("./../../../view/renderData/drawLogoDataTo2D.js");

var LogoInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    $(this.controlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    if(this.interactionModel.handle)
        this.handle = new HandleView(self, this.gui, 0, this.interactionModel.handle(), parentGroup, layers);

    this.draw();

    if(this.interactionModel) {
        this.interactionModel.selected.onChange(this, function (member, old, value) {
            if (self.data.isAlive()) self.setSelected(value);
        }, 10);
    }

    this.data.onBubble(this, function (remote) {
        if (self.data.isAlive()) {
            self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
        }
    }, 10);

    this.cameraModel.viewS.onChange(self, function () {
        if (self.data.isAlive()) {
            self.gui.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
        }
    }, 10);
};
lib_core.mixin(LogoInteractionView, editor_2d.DrawingElement);

module.exports = LogoInteractionView;

LogoInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();
    if(!this.data.isAlive()) return;

    //TODO: still XSS vulnerability here
    var svgData = logoDataToSVG(this.data);

    // draw visible
    this.gui.svg.add(this.elementSvgGroup, svgData);

    // draw control
    this.gui.svg.add(this.controlGroup, svgData);

    // this.control = $(":nth-last-child(1)", this.controlGroup);
    // this.resizeControl();
};

LogoInteractionView.prototype.resizeControl = function (event) {
    // if(this.control) this.control.attr("stroke-width", this.data.strokeWidth() + 4 / this.cameraModel.viewS());
};

LogoInteractionView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};
